// extracted by mini-css-extract-plugin
export var active = "WinterOfDoingScheduleSwitch-module--active--679cd";
export var switchStyle = "WinterOfDoingScheduleSwitch-module--switchStyle--52f65";